import { dynamic } from '@unifyapps/carbon/external/dynamic';
import { withSuspense } from '@unifyapps/hooks/withSuspense';

const LazyImportEmptyState = dynamic(
  () => import(/* webpackChunkName: "Image-EmptyState" */ './EmptyState'),
);

export default withSuspense(LazyImportEmptyState);
